var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrap",staticClass:"col-lg-3 hidden-md-down minicart-wrap",attrs:{"data-element":"minicart-wrap"}},[_c('div',{ref:"cart",staticClass:"minicart-cont",class:{active: _vm.fixed, btm: _vm.bottom},attrs:{"data-element":"minicart"}},[_vm._t("miniCart"),_vm._t("portingForm"),_vm._t("nowBuying")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }